module.exports = __webpack_public_path__ + "img/CUS_N_1-1.c9fc2e94.jpg";